/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Error messages surfaced to the user when reCAPTCHA verification hard-fails.
// The challenge-control signals ("additional challenge required" /
// "challenge failed") are recognized inside the shared-ui
// useRecaptchaWithFallback hook, so they no longer live here.
export const RECAPTCHA_ERROR =
    'Our system has detected abnormal activity from your computer network. Please try again.';
export const RECAPTCHA_ERROR2 =
    'Our system has detected abnormal activity from your computer network. Please try refreshing the page or re-logging into your account.';
